export default "__VITE_ASSET__Djih2z6u__"